// 示例代码仅用于展示思路，具体实现需要根据所选免费IP地址库进行调整

export const isAndroidUserInChina = () => {
  // 获取用户IP地址
  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const country = data.country;

      // 判断是否为中国境内用户
      if (country === "CN") {
        console.log("This is an Android user from China.");
        return true;
      } else {
        console.log("This is an Android user from outside China.");
        return false;
      }
    })
    .catch((error) => {
      console.error("Failed to determine the user's location:", error);
    });
};
export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// 手机号验证格式
export function validatePhone(phone) {
  const regex = /^\d+$/;
  return regex.test(phone);
}
